function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M.75 52h52V0h-52z"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeWidth: 2,
  d: "M33.75 47V6.037c0-1.125.912-2.037 2.037-2.037h9.926c1.125 0 2.037.912 2.037 2.037v38.926A2.037 2.037 0 0 1 45.713 47H33.75zm-14 0V21.037c0-1.125.912-2.037 2.037-2.037H33.75v28h-14zm0-13v13H7.787a2.037 2.037 0 0 1-2.037-2.037v-8.926c0-1.125.912-2.037 2.037-2.037H19.75z"
}));

var SvgGrowthbudg = function SvgGrowthbudg(props) {
  return React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MyIgaGVpZ2h0PSI1MiIgdmlld0JveD0iMCAwIDUzIDUyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTS43NSA1Mmg1MlYwaC01MnoiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiMzRkMwQzQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTMzLjc1IDQ3VjYuMDM3YzAtMS4xMjUuOTEyLTIuMDM3IDIuMDM3LTIuMDM3aDkuOTI2YzEuMTI1IDAgMi4wMzcuOTEyIDIuMDM3IDIuMDM3djM4LjkyNkEyLjAzNyAyLjAzNyAwIDAgMSA0NS43MTMgNDdIMzMuNzV6TTE5Ljc1IDQ3VjIxLjAzN2MwLTEuMTI1LjkxMi0yLjAzNyAyLjAzNy0yLjAzN0gzMy43NXYyOGgtMTR6TTE5Ljc1IDM0djEzSDcuNzg3YTIuMDM3IDIuMDM3IDAgMCAxLTIuMDM3LTIuMDM3di04LjkyNmMwLTEuMTI1LjkxMi0yLjAzNyAyLjAzNy0yLjAzN0gxOS43NXoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgGrowthbudg as ReactComponent };